"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CandidateExperienceSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_1 = require("../shared");
const candidate_enum_1 = require("./candidate.enum");
exports.CandidateExperienceSchema = zod_1.default.object({
    id: shared_1.UUIDSchema,
    candidateId: shared_1.UUIDSchema,
    entityId: shared_1.UUIDSchema,
    yearOfExperience: shared_1.NonNegativeIntegerSchema.nullable(),
    experienceType: candidate_enum_1.ExperienceTypeEnum,
    createdAt: shared_1.ISODateTimeSchema,
    updatedAt: shared_1.ISODateTimeSchema,
});
